import { render, staticRenderFns } from "./stadium_base.vue?vue&type=template&id=267bcbb9&scoped=true&"
import script from "./stadium_base.vue?vue&type=script&lang=ts&"
export * from "./stadium_base.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_base.vue?vue&type=style&index=0&id=267bcbb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267bcbb9",
  null
  
)

export default component.exports